<template>
  <div class="edit standing">
    <div class="standing-bar">
      <el-row>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(1)"
                   @click="editStart = false">修改
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(2)" @click="checkForm">保存
        </el-button>
        <!--<el-button type="danger" size="small" icon="el-hg-icon-delete" @click="operationDeleteEven" :disabled="buttonStart(1)">作废</el-button>-->
        <el-button type="primary" size="small" icon="el-hg-icon-audit" @click="doAudit" :disabled="buttonStart(3)">审核
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-icon-back" @click="doCancleAudit" :disabled="buttonStart(3)">退审</el-button>-->
        <!--<el-button type="primary" size="small" icon="el-icon-circle-check" @click="doFinish" :disabled="buttonStart(4)">完成</el-button>-->
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="detail(id)"
                   :disabled="buttonStart(4)">刷新
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-hg-icon-downloadf" :disabled="buttonStart(5)">导出</el-button>-->
        <el-button type="primary" size="small" icon="el-icon-paperclip" @click="enclosureStart = !enclosureStart">附件
        </el-button>
      </el-row>
    </div>
    <div :class="[editStart ? 'edit_modle': 'edit_modle editStart']" :style="{height: editModleHeight + 'px'}">
      <div class="edit_from" ref="edit_from">
        <el-form ref="topForm" :model="formInline" :rules="rules" class="top-form" label-width="80px" size="mini">
          <el-form-item v-for="(itme, key) in fromList" :prop="itme.key" :key="key">
            <span slot="label" v-if="!itme.isNoShow">
              <span v-if="itme.must"><span style="color: red">*</span>{{itme.label}}</span>
              <span v-else>{{itme.label}}</span>
            </span>
            <div v-if="!itme.isNoShow">
              <el-input v-if="itme.type === 'input'" v-model="formInline[itme.key]" placeholder="请输入内容" clearable
                        :type="itme.contentType==='number'?'number':'text'"
                        :class="[itme.contentType==='number'?'alignRight':'']"
                        :disabled="itme.disabled" @change="inputChangeEven(itme.key)"/>
              <el-input v-if="itme.type === 'inputButton'" v-model="formInline[itme.key]" placeholder="请输入内容" clearable
                        :type="itme.contentType==='number'?'number':'text'"
                        :disabled="itme.disabled" @change="inputChangeEven(itme.key)">
                <el-button slot="append" v-if="itme.tips !== '列批号'" @click="openDialog(itme.dialog, null, itme.code)"
                           icon="el-icon-more" :disabled="editStart"></el-button>
                <template slot="append" v-else>
                  <p style="cursor: pointer; text-align: center;" @click="openDialog(itme.dialog, null, itme.code)">
                    {{itme.tips}}</p>
                </template>
              </el-input>
              <el-select v-if="itme.type === 'select'" filterable v-model="formInline[itme.key]" allow-create
                         placeholder="请输入内容" :disabled="editStart">
                <el-option
                  v-for="(value, key) in itme.list"
                  :key="key"
                  :label="value[itme.labelName]"
                  :value="value[itme.value]">
                </el-option>
              </el-select>
              <el-autocomplete
                v-if="itme.type === 'inputCustom'"
                :disabled="editStart"
                v-model="formInline[itme.key]"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="inputSelectEven">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.BLNO }}</div>
                </template>
              </el-autocomplete>
              <el-date-picker
                @change="datePickerEven(itme.key)"
                :disabled="editStart"
                v-if="itme.type === 'datePicker'"
                v-model="formInline[itme.key]"
                type="datetime"
                :picker-options="pickerOptionsEnd(itme.key)"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <el-row :gutter="4" v-if="$route.name === 'billLadingLading' || $route.name === 'addBillLadingLading'">
          <el-col :span="16">
            <el-form label-position="right" label-width="80px" size="mini">
              <el-form-item label="特殊要求">
                <el-input
                  :disabled="editStart"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="formInline.SpecialRequest"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="formInline.Remark" placeholder="请输入内容" :disabled="editStart"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <el-form label-position="right" label-width="90px" size="mini">
              <el-form-item label="需要铅封号">
                <el-switch
                  :disabled="editStart"
                  v-model="formInline.IsNon"
                  active-color="#13ce66">
                </el-switch>
              </el-form-item>
              <el-form-item label="制表人">
                <el-input v-model="formInline.OperatorName" placeholder="请输入内容" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :disabled="true" label="制表日期">
                <el-input v-model="formInline.CreateDate" placeholder="请输入内容" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row :gutter="4" v-else-if="$route.name === 'billLadingUnload' || $route.name === 'addBillLadingUnload'">
          <el-col :span="16">
            <el-form label-position="right" label-width="80px" size="mini">
              <el-form-item label="备注">
                <el-input v-model="formInline.Remark" placeholder="请输入内容" :disabled="editStart"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <el-form :inline="true" label-position="right" label-width="80px" size="mini">
              <el-form-item label="需要铅封号">
                <el-switch
                  :disabled="editStart"
                  v-model="formInline.IsNon"
                  active-color="#13ce66">
                </el-switch>
              </el-form-item>
              <el-form-item label="现场化验">
                <el-switch
                  :disabled="editStart"
                  v-model="formInline.NeedAssay"
                  active-color="#13ce66">
                </el-switch>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="23">
            <el-form label-position="right" label-width="80px" size="mini">
              <el-form-item label="特殊要求">
                <el-input
                  :disabled="editStart"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="formInline.SpecialRequest"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="edit_table" ref="edit_table">
        <div class="tableCon">
          <div class="tableContent-title">批号信息</div>
          <div class="tableContent">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="addNewBatchNumberData"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" @click="batchNumberDelete"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" @click="detail(id)"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-upload" @click="complete" :disabled="editStart"></el-button>-->
              </div>
              <sp-table
                ref="batchTable"
                :parentTableData.sync="batchFilterData"
                :parentCol.sync="batchNumberCol"
                :drag-drop='true'
                @addNewData="addNewBatchNumberData"
                @selection-change="batchNumberSelectionChange"
                :is-edit="!editStart"
                class="batchTable"
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column align="center" label="序号" type="index" width="50"/>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in batchNumberCol" :key="index"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <div class="auto-input" v-if="!item.readOnly">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <div v-else-if="carOrderBatchComponent.inputButton.indexOf(item.field) > -1">
                        <el-input size="mini" v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容">
                          <el-button slot="append"
                                     @click="openDialog(batchNumberCol[index].dialog, scope,null,batchNumberList)"
                                     icon="el-icon-more"></el-button>
                          <!--<template slot="append">-->
                          <!--<p style="cursor: pointer; text-align: center;" @click="openDialog(batchNumberCol[index].dialog, scope.$index)">-->
                          <!--{{batchNumberCol[index].tips}}</p>-->
                          <!--</template>-->
                        </el-input>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div class="span">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]" :disabled="true" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[batchNumberCol[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
        <div class="tableCon">
          <div class="tableContent-title">车号信息</div>
          <div class="tableContent">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="addNewLicenseNumberData"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" @click="licenseNumberDelete"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" @click="detail(id)"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="批量导入车号" placement="bottom" v-if="editStart">
                  <el-button size="small" type="primary" icon="el-icon-upload" :disabled="editStart"></el-button>
                </el-tooltip>

                <el-upload class="upload-demo" action="" multiple :before-upload="licenseFileEven" v-else>
                  <el-tooltip class="item" effect="dark" content="批量导入车号" placement="bottom">
                    <el-button size="small" type="primary" icon="el-icon-upload"></el-button>
                  </el-tooltip>
                </el-upload>
                <!--<el-button size="small" type="primary" icon="el-icon-upload" @click="complete" :disabled="editStart"></el-button>-->
              </div>
              <sp-table
                ref="licenseTable"
                :parentTableData.sync="licenseFilterData"
                :parentCol.sync="licenseNumberClo"
                :drag-drop='true'
                @addNewData="addNewLicenseNumberData"
                @selection-change="licenseNumberSelectionChange"
                :is-edit="!editStart"
                :key-dom=1
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in licenseNumberClo" :key="index"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <div class="auto-input" v-if="!item.readOnly">
                      <div v-if="carOrderListComponent.select.indexOf(item.field) > -1 ">
                        <el-input size="mini" v-model="scope.row[licenseNumberClo[index].field]"
                                  placeholder="请输入内容"></el-input>
                      </div>
                      <div align="center" v-else-if="carOrderListComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[licenseNumberClo[index].field]"></el-checkbox>
                      </div>
                      <div v-else-if="carOrderListComponent.datePicker.indexOf(item.field) > -1">
                        <el-date-picker
                          v-model="scope.row[licenseNumberClo[index].field]"
                          type="datetime"
                          size="mini"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期时间">
                        </el-date-picker>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[licenseNumberClo[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div class="span">
                      <div align="center" v-if="carOrderListComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[licenseNumberClo[index].field]" :disabled="true"></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[licenseNumberClo[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <grid-dialog :show="showGuestId"
                 title="客户选择"
                 :default-params="guestIdDefaultParams"
                 :default-values.sync="guestIdDefaultValue"
                 :default-keys="guestIdDefaultKeys"
                 :ref-value.sync="formInline"
                 :page-type="'add'"
                 :grid-config="guestIDByConditionsList"
                 @close="showGuestId = !showGuestId"></grid-dialog>
    <grid-dialog :show="showBargainID"
                 title="合同号选择"
                 :page-type="'add'"
                 :default-params="bargainIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="bargainDefaultValue"
                 :default-keys="bargainDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showBargainID = !showBargainID"></grid-dialog>
    <grid-dialog :show="showGoodsID"
                 title="产品选择"
                 :page-type="'add'"
                 :default-params="refGoodsDefaultParams"
                 :grid-config="refGoodsByConditionsList"
                 :default-values.sync="goodsDefaultValue"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showGoodsID = !showGoodsID"></grid-dialog>
    <grid-dialog :show="showgetTGuest"
                 title="提货人"
                 :page-type="'add'"
                 :default-params="TGuestIDDefaultParams"
                 :grid-config="TGuestIDByConditions"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="formInline"
                 @close="showgetTGuest = !showgetTGuest"></grid-dialog>
    <grid-dialog :show="showTankID"
                 title="罐号选择"
                 :page-type="'add'"
                 :default-params="TankIDDefaultParams"
                 :grid-config="TankIDByConditions"
                 :default-values.sync="TankIDDefaultValue"
                 :default-keys="TankIDDefaultKey"
                 :ref-list.sync="batchNumberList" :ref-list-index.sync="currentTank"
                 @close="showTankID = !showTankID"></grid-dialog>
    <grid-dialog :show="showAttachBargain"
                 title="附加合同"
                 :page-type="'add'"
                 :default-params="AttachBargainDefaultParams"
                 :grid-config="bargainIDByConditionsList"
                 :default-values.sync="AttachBargainDefaultValue"
                 :default-keys="AttachBargainDefaultKey"
                 :ref-value.sync="formInline"
                 @close="showAttachBargain = !showAttachBargain">
    </grid-dialog>
    <Dialog title="附件" :width="600" :height="400" :visible="enclosureStart" @close="enclosureStart = !enclosureStart">
      <div class="grid-contain dialog edit">
        <div style="margin-bottom: 20px">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="uploadFileDesc = !uploadFileDesc">上传文件
          </el-button>
        </div>
        <div class="grid-table">
          <sp-table
            ref="batchTable"
            :parentTableData.sync="annexDetailList"
            :parentCol.sync="enclosureAction">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" label="序号" type="index" width="50"/>
            <sp-table-column v-for="(item, index) in enclosureAction" :key="index" :width="item.width">
              <template slot="header">
                <p>{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" v-if="item.field !== 'edit'">
                  <p>{{scope.row[enclosureAction[index].field]}}</p>
                </div>
                <div class="span" v-else>
                  <el-button type="primary" size="small" @click="fileDownload(scope.row)">下载</el-button>
                  <el-button type="danger" size="small" @click="fileDelete(scope.row)">删除</el-button>
                  <!--<el-button type="primary" size="small">删除</el-button>-->
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </Dialog>
    <Dialog title="上传文件说明" :width="400" :height="100" :visible="uploadFileDesc"
            @close="uploadFileDesc = !uploadFileDesc">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px">
          <el-form-item label="文件说明">
            <el-input v-model="desc" placeholder="请输入说明后再选择文件"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-upload
            class="upload-demo"
            action=""
            name="file"
            :show-file-list="false"
            :http-request="beforeAvatarUpload">
            <el-button size="small" icon="el-hg-icon-save" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="uploadFileDesc = !uploadFileDesc"
                     style="margin-left: 20px">关 闭
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import dayjs from 'dayjs';
  import gridDialog from '@/components/gridDialog';
  import Dialog from '@/components/dialog';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];

  export default {
    name: 'edit',
    components: {
      spTable,
      spTableColumn,
      gridDialog,
      Dialog,
    },
    data() {
      return {
        editStart: true,
        addStart: true,
        id: '',
        type: '',
        activeName: '批号信息',
        showGoodDic: false,
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showgetTGuest: false,
        showLocation: false,
        showTankID: false,
        showAttachBargain: false,
        enclosureStart: false,
        uploadFileStart: false,
        uploadFileDesc: false,
        goodDIcDefaultParams: {
          type: 'BUSINESS',
          url: 'getGoods',
          params: {
            goodsId: '',
          },
        },
        batchNumberOriginData: {},
        licenseNumberOriginData: {},
        batchNumberList: [],
        licenseNumberList: [],
        bargainList: [],
        getRefGoodsList: [],
        guestIDList: [],
        getBlnoList: [],
        rules: {
          Name: [{
            required: true,
            message: '请选择产品',
            trigger: 'change'
          }],
          CEGoodsName: [{
            required: true,
            message: '请选择产品',
            trigger: 'change'
          }],
          BLNO: [{
            required: true,
            message: '请输入提单号',
            trigger: 'blur'
          }], BLNumber: [{
            required: true,
            message: '请输入提单数',
            trigger: 'blur'
          }], TGuestName: [{
            required: true,
            message: '请选择提货人',
            trigger: 'change'
          }], BargainID: [{
            required: true,
            message: '请选择合同号',
            trigger: 'change'
          }]
        },
        formInline: {
          IsNon: false,
          Remark: '',
          SpecialRequest: '',
          OperatorID: '',
          CreateDate: '',
          Name: '',
          GuestID: '',
          CEGoodsName: '', // 产品名称
          GoodsID: '', // 产品id
          BLNumber: '', // 列单数
          BargainID: '', // 合同编号
          BillID: '', // 流水号
          Location: '',
        },
        licenseNumberUserSelectId: [], // 批号选择id集合
        batchNumberUserSelectId: [], // 车号选择id集合
        detailInfo: {},
        getServiceIdList: [],
        MainOrder: '',
        guestIdDefaultValue: {
          Name: 'Name',
          GuestID: 'GuestID',
        },
        guestIdDefaultKeys: 'GuestId',
        goodsDefaultValue: {
          CEGoodsName: 'CEGoodsName',
          GoodsID: 'GoodsID',
        },
        goodsDefaultKeys: 'GoodsID',
        TGuestIDDefaultValue: {
          Name: 'GuestName',
          GuestID: 'GuestID',
        },
        TGuestIDDefaultKey: 'GuestID',
        TankIDDefaultKey: 'GuestID',
        currentTank: 0,
        bargainDefaultValue: {
          BargainID: 'BargainID',
        },
        bargainDefaultKeys: 'BargainID',
        AttachBargainDefaultValue: {
          BatchNo: 'Location'
        },
        AttachBargainDefaultKey: 'BatchNo',
        carOrderBatchComponent: {
          select: ['BatchID'],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax'],
          inputButton: ['TankID'],
        },
        carOrderListComponent: {
          select: [],
          checked: ['IsDate'],
          datePicker: ['CarBeginDate', 'CarEndDate'],
          input: ['SmallBLNO']
        },
        OrderType: false, // 判断是否是装车还是卸车
        batchNumberCol: [],
        licenseNumberClo: [],
        Step: '', // 审核步骤
        fileUpload: '',
        desc: '',
        annexDetailList: [],
        editModleHeight: 0,
        detailTable: {},
        orderType: ''
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        guestIDByConditionsList: 'dictionary/guestIDByConditionsList',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        carOrderBatch: 'dictionary/carOrderBatch',
        carOrderList: 'dictionary/carOrderList',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditions',
        TankIDByConditions: 'dictionary/TankIDByConditions',
        dictionaryAction: 'dictionary/dictionaryAction',
        // enclosureAction: 'dictionary/enclosureAction',
      }),
      fromList() {
        let list = [];
        if (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') {
          list = [
            {label: '订单号', key: 'MainOrderID', type: 'input', disabled: true, must: true,},
            {
              label: '客户',
              key: 'Name',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGuestId',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '合同号',
              key: 'BargainID',
              type: 'inputButton',
              tips: '...',
              dialog: 'showBargainID',
              disabled: this.editStart,
              must: true,
              code: 4052,
            },
            {
              label: '产品',
              key: 'CEGoodsName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGoodsID',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '提单号',
              key: 'BLNO',
              type: 'input',
              list: this.getBlnoList,
              labelName: 'BLNO',
              value: 'BLNO',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '提单数',
              key: 'BLNumber',
              type: 'inputButton',
              tips: '列批号',
              dialog: 'batch',
              disabled: this.editStart,
              contentType: 'number',
              must: true,
            },
            {label: '预计日期', key: 'PreDate', type: 'datePicker', disabled: this.editStart,},
            {
              label: '开始时间',
              key: 'BLBeginDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
              disabled: this.editStart,
            },
            {
              label: '有效天数',
              key: 'AvailableDays',
              type: 'input',
              default: 4,
              disabled: this.editStart,
              contentType: 'number',
            },
            {
              label: '结束时间',
              key: 'BLEndDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date().setDate(new Date().getDate() + 3))} 23:59:59`,
              disabled: this.editStart,
            },
            {
              label: '提货人',
              key: 'GuestName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showgetTGuest',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '附加合同',
              key: 'Location',
              type: 'inputButton',
              tips: '...',
              dialog: 'showAttachBargain',
              disabled: this.editStart,
            },
            {
              label: '制表人',
              key: 'OperatorName',
              type: 'input',
              disabled: true,
              default: this.userInfor.nic,
              isNoShow: true,
            },
            {
              label: '制表日期',
              key: 'CreateDate',
              type: 'input',
              disabled: true,
              default: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              isNoShow: true,
            },
          ];
        }
        else if (this.$route.name === 'billLadingUnload' || this.$route.name === 'addBillLadingUnload') {
          list = [
            {label: '订单号', key: 'MainOrderID', type: 'input', disabled: true, must: true,},
            {
              label: '客户',
              key: 'Name',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGuestId',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '合同号',
              key: 'BargainID',
              type: 'inputButton',
              tips: '...',
              dialog: 'showBargainID',
              disabled: this.editStart,
              must: true,
              code: 4052,
            },
            {
              label: '产品',
              key: 'CEGoodsName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGoodsID',
              disabled: this.editStart,
              must: true,
            },
            {label: '提单数', key: 'BLNumber', type: 'input', disabled: this.editStart, must: true,},
            {
              label: '提单号',
              key: 'BLNO',
              type: 'inputCustom',
              list: this.getBlnoList,
              labelName: 'BLNO',
              value: 'BLNO',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '开始时间',
              key: 'BLBeginDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
              disabled: this.editStart,
            },
            {
              label: '结束时间',
              key: 'BLEndDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date().setDate(new Date().getDate() + 3))} 23:59:59`,
              disabled: this.editStart,
            },
            {label: '有效天数', key: 'AvailableDays', type: 'input', default: 4, disabled: this.editStart,},
            {label: '预计日期', key: 'PreDate', type: 'datePicker', disabled: this.editStart,  must: true,},
            {label: '制表人', key: 'OperatorName', type: 'input', disabled: true, default: this.userInfor.nic,},
            {
              label: '制表日期',
              key: 'CreateDate',
              type: 'input',
              disabled: true,
              default: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            },
          ];
        }
        return list;
      },
      guestIdDefaultParams() {
        let params = {
          guestId: this.formInline.Name ? this.formInline.Name : '',
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          serviceId: this.orderTypeC('09', '08'),
        };
        let info = {
          type: 'BUSINESS',
          url: 'getRefVGuest',
          params,
        };
        return info;
      },
      bargainIDDefaultParams() {
        let params = {
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          serviceId: this.orderTypeC('09', '08'),
        };
        let info = {
          type: 'BUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        };
        return info;
      },
      refGoodsDefaultParams() {
        let params = {
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getRefGoods',
          params,
        };
        return info;
      },
      TGuestIDDefaultParams() {
        let params = {
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getOutCarRefTGuest',
          params,
        };
        return info;
      },
      TankIDDefaultParams() {
        let params = {
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          billId: this.formInline.BillID,
          location: this.formInline.Location,
        };
        let info = {
          type: 'BUSINESS',
          url: this.orderTypeC('getOutCarTank', 'getInCarTank'),
          params,
        };
        return info;
      },
      AttachBargainDefaultParams() {
        let params = {
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getAttachBargain',
          params,
        };
        return info;
      },
      enclosureAction() {
        return [
          {width: 160, title: '附件描述', field: 'explain'},
          {width: 160, title: '附件名称', field: 'annexname'},
          {width: 160, title: '添加人', field: 'operatorid'},
          {width: 160, title: '添加时间', field: 'adddate'},
          {width: 160, title: '编辑', field: 'edit'},
        ]
      },
      batchFilterData() {
        let arr = [];
        this.batchNumberList.forEach(itme => {
          if (itme.updateFlg !== 'delete') {
            arr.push(itme);
          }
        });
        return arr;
      },
      licenseFilterData() {
        let arr = [];
        this.licenseNumberList.forEach(itme => {
          if (itme.updateFlg !== 'delete') {
            arr.push(itme);
          }
        });
        return arr;
      },
      TankIDDefaultValue() {
        if (this.orderType === 'load') {
          return {
            AccountID: 'AccountID',
            BargainID: 'BargainID',
            BatchNo: 'BatchID',
            CanNumber: 'CanNumber',
            GoodsID: 'GoodsID',
            GoodsName: 'GoodsName',
            GuestID: 'GuestID',
            GuestName: 'GuestName',
            IsInTrade: 'IsInTrade',
            IsOutTrade: 'IsOutTrade',
            IsTax: 'IsTax',
            LockNumber: 'LockNumber',
            MadeNumber: 'MadeNumber',
            OrderNumber: 'OrderNumber',
            PassNo: 'PassNo',
            Remark: 'Remark',
            TankID: 'TankID',
          };
        }
        else if (this.orderType === 'unload') {
          return {
            TankID: 'TankID',
            IsInTrade: 'IsInTrade',
            IsOutTrade: 'IsOutTrade',
            IsTax: 'IsTax',
            InOrderNumber: 'InOrderNumber',
            Number: 'Number',
            RealNumber: 'RealNumber',
            AffirmNumber: 'AffirmNumber',
            StateName: 'StateName',
            Remark: 'Remark',
          };
        }
      },
    },
    activated() {
      if (this.id !== this.$route.query.id) {
        this.init();
      }
    },
    mounted() {
      this.$route.name === 'addBillLadingLading' || this.$route.name === 'billLadingLading' ? this.orderType = 'load' : '';
      this.$route.name === 'addBillLadingUnload' || this.$route.name === 'billLadingUnload' ? this.orderType = 'unload' : '';

      this.editModleHeight = window.document.body.clientHeight - 139;
    },
    methods: {
      ...mapActions({
        getGoodDicList: 'dictionary/getGoodDicList',
        getGuestIDByConditionsList: 'dictionary/getGuestIDByConditionsList',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCarOrderBatch: 'dictionary/getCarOrderBatch',
        getCarOrderList: 'dictionary/getCarOrderList',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditions',
        getTankIDByConditions: 'dictionary/getTankIDByConditions',
        getDictionaryAction: 'dictionary/getDictionaryAction',
        // getEnclosureAction: 'dictionary/getEnclosureAction',
      }),
      orderTypeC(a, b) {
        let re;
        this.orderType === 'load' ? re = a : '';
        this.orderType === 'unload' ? re = b : '';
        return re;
      },
      inputSelectEven(value) {
        this.formInline.BLNO = value.BLNO
      },
      querySearch(queryString, cb) {
        let restaurants = this.getBlnoList;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      // 车号文件上传
      licenseFileEven(file) {
        this.uploadFileAPI(file);
        return false;
      },
      uploadFileAPI(file) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          let base64 = e.target.result.split(',')[1];
          this.$services.postLoading({
            type: 'BUSINESS',
            url: 'getListExcelCarOrderList',
            params: {
              carListExcel: base64,
              suffix: file.name.split('.')[1],
            },
          }).then(res => {
            this.$services.postLoading({
              type: 'BUSINESS',
              url: 'getListExcelCarOrderList',
              params: {
                carListExcel: base64,
                suffix: file.name.split('.')[1],
              },
            }).then(res => {
              if (res.bean) {
                res.bean.forEach(itme => {
                  this.licenseNumberList.push(JSON.parse(JSON.stringify(
                    Object.assign(this.licenseNumberOriginData, {
                      uid: this.$utils.getUid(),
                      id: this.licenseNumberList.length + 1,
                      BillID: Number(this.$route.query.id),
                      SmallBLNO: this.formInline.BLNO,
                      AccountID: this.userInfor.accountId,
                      ListId: this.licenseNumberList.length + 1,
                      ShowIndex: 1,
                      State: 0,
                      updateFlg: 'add',
                    }, itme),
                  )));
                });
              }
            });
          });
        };
      },
      getType(file) {
        let filename = file;
        let index1 = filename.lastIndexOf('.');
        let index2 = filename.length;
        let type = filename.substring(index1, index2);
        return type;
      },
      // 按钮状态控制
      buttonStart(type) {
        let start = false;
        if (this.$route.name === 'addBillLadingLading' || this.$route.name === 'addBillLadingUnload') {
          start = true;
        }
        switch (type) {
          case 1:
            if (!this.editStart) {
              start = true;
            }
            break;
          case 2:
            if ((this.$route.name === 'addBillLadingLading' || this.$route.name === 'addBillLadingUnload') || !this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 3:
            if (!this.editStart) {
              start = true;
            }
            break;
        }
        return start;
      },
      init() {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.MainOrder = this.$route.query.MainOrder;
        this.tableOriginData();
        this.OrderType = (this.$route.name === 'addBillLadingLading' || this.$route.name === 'billLadingLading') ? false : true;
        this.getGoodDicList(this.OrderType);
        this.getGuestIDByConditionsList(this.OrderType);
        this.getBargainIDByConditionsList(this.OrderType);
        this.getRefGoodsByConditionsList(this.OrderType);
        this.getCarOrderBatch(this.OrderType);
        this.getCarOrderList(this.OrderType);
        this.getTGuestIDByConditions(this.OrderType);
        this.getTankIDByConditions(this.OrderType);
        // this.getEnclosureAction();
        if (this.$route.name === 'addBillLadingLading' || this.$route.name === 'addBillLadingUnload') {
          this.getServiceId();
        }
        if (this.$route.query.type === 'edit') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.detail(this.id);
          this.editStart = false;
        }
        if (this.$route.query.type === 'info') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.detail(this.id);
        }
        if (this.$route.query.type === 'add') {
          this.editStart = false;
          this.formInline.BillID = this.id;
          this.formInline.MainOrderID = this.MainOrder;
        }
        this.getBlnoEven();
        this.getCheckChecking();
        this.getCheckProcess();
        this.getAvailableDays();
        this.annexDetailAPI();
      },
      // 时间范围控制
      pickerOptionsEnd(val) {
        let data = {};
        if (val === 'BLEndDate') {
          data = {
            disabledDate: time => (
              time.getTime() < dayjs(this.formInline.BLBeginDate).valueOf() - 24 * 1000 * 60 * 60
            ),
          };
        }
        return data;
      },
      // 附件上传前的钩子
      beforeAvatarUpload(file) {
        if (this.desc) {
          this.annexUploadAPI(file);
        }
        else {
          this.$message({
            message: '请填写上传附件的说明',
            type: 'warning',
          });
        }
        return false;
      },
      // 单据的附件详情查询
      annexDetailAPI() {
        this.$services.post({
          type: 'ERP',
          url: 'annexDetail',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.$route.query.id,
          },
        }).then(res => {
          this.annexDetailList = res.bean;
        });
      },
      // 单据的附件上传
      annexUploadAPI(file) {
        let listid = 0
        if (this.annexDetailList.length > 0) {
          this.annexDetailList.forEach(itme => {
            if (listid < itme.listid) {
              listid = itme.listid;
            }
          });
        }
        let data = {
          updateFlg: 'add',
          accountid: this.userInfor.accountId,
          tableid: 'MainOrder',
          billsid: this.$route.query.id,
          listid: listid + 1,
          showindex: listid + 1,
          explain: this.desc,
          annexname: file.file.name,
          operatorid: this.userInfor.userName,
          adddate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          annexsize: file.file.size / 1000,
        };
        this.$services.postUrlParams({
          type: 'ERP',
          url: 'annexUpload',
          urlParams: data,
          params: file.file,
        }).then(res => {
          this.uploadFileDesc = false;
          this.annexDetailAPI();
        });
      },
      // 单据附件删除
      fileDelete(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexRemove',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.$route.query.id,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.annexDetailAPI();
          this.$message({
            message: '删除成功',
            type: 'success',
          });
        });
      },
      // 单据附件的下载
      fileDownload(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexDownload',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.$route.query.id,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.$utils.downLoad(res, itme.annexname)
        });
      },
      // 获取默认有效天数
      getAvailableDays() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getAvailableDays',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.$set(this.formInline, 'AvailableDays', res.bean);
        });
      },
      // 审核
      doAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doAudit',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: this.Step,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.editStart = true;
          this.detail(this.id);
          this.$forceUpdate();
        });
      },
      // 退审
      doCancleAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doCancleAudit',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: -1,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 完成
      doFinish() {
        this.$services.post({
          type: 'ERP',
          url: 'doFinish',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
        });
      },
      // 作废
      operationDeleteEven() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'doBlankOut',
          params: {
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 获取单据审核信息
      getCheckChecking() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckChecking',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billId: this.id,
          },
        }).then(res => {
          if (res.bean) {
            this.Step = res.bean.length;
          }
          else {
            this.Step = 0;
          }
        });
      },
      // 获取单据审核流程信息，窗体加载时获取
      getCheckProcess() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckProcess',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
          },
        }).then(res => {
        });
      },
      openDialog(key, row = null, code, orgList) {
        let orgIndex;
        orgList ? orgIndex = orgList.findIndex(x => {
          return x.uid == row.row.uid;
        }) : '';
        if (orgIndex) this.currentTank = orgIndex;
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        if (code) this.getDictionaryAction(code);
        this[key] = !this[key];
      },
      async getInCarBatchId() {
        if (!this.formInline.BLNumber) {
          this.$message({
            message: '请填写提单数',
            type: 'warning',
          });
        }
        const {bean} = await this.$services.post({
          type: 'BUSINESS',
          url: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? 'getOutCarBatchId' : 'getInCarBatchId',
          params: {
            accountId: this.userInfor.accountId,
            bargainId: this.formInline.BargainID,
            goodsId: this.formInline.GoodsID,
            guestId: this.formInline.GuestID,
            billId: this.formInline.BillID,
            blNumber: this.formInline.BLNumber,
          },
        });
        bean.forEach((itme, key) => {
          itme.updateFlg = 'add';
        });
        this.batchNumberList = bean;
      },
      // 表格初始化数据处理
      tableOriginData() {
        this.fromList.forEach(itme => {
          if (itme.key) this.$set(this.formInline, itme.key, '');
          if (itme.default) this.$set(this.formInline, itme.key, itme.default);
        });
        this.batchNumberCol.forEach(itme => {
          if (itme.field === 'IsInTrade' || itme.field === 'IsOutTrade' || itme.field === 'IsTax') {
            this.$set(this.batchNumberOriginData, itme.field, false);
          }
          else {
            this.$set(this.batchNumberOriginData, itme.field, null);
          }
        });
        this.licenseNumberClo.forEach(itme => {
          if (itme.field === 'IsBL' || itme.field === 'IsDate') {
            this.$set(this.licenseNumberOriginData, itme.field, false);
          }
          this.$set(this.licenseNumberOriginData, itme.field, null);
        });
      },
      // 取装卸车服务编号
      getServiceId() {
        let type;
        if (this.$route.name === 'addBillLadingLading') {
          type = 3;
        }
        else if (this.$route.name === 'addBillLadingUnload') {
          type = 2;
        }
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getServiceId',
          params: {
            accountId: this.userInfor.accountId,
            type,
            // operatorId: this.userInfor.id,
            operatorId: 'Admin',
          },
        }).then(res => {
          this.getServiceIdList = res.bean;
        });
      },
      // 获取台账详情
      detail(id) {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'detail',
          params: {
            accountId: this.userInfor.accountId,
            billId: id,
          },
        }).then(({bean}) => {
          this.detailTable = bean;
          this.$set(this.formInline, 'BillID', bean.BillID);
          this.$set(this.formInline, 'GuestID', bean.GuestID);
          this.$set(this.formInline, 'Name', bean.GuestName);
          this.$set(this.formInline, 'BargainID', bean.BargainID);
          this.$set(this.formInline, 'CEGoodsName', bean.GoodsName);
          this.$set(this.formInline, 'GoodsID', bean.GoodsID);
          this.$set(this.formInline, 'BLNO', bean.BLNO);
          this.$set(this.formInline, 'BLNumber', bean.BLNumber);
          this.$set(this.formInline, 'BLBeginDate', bean.BLBeginDate);
          this.$set(this.formInline, 'BLEndDate', bean.BLEndDate);
          this.$set(this.formInline, 'PreDate', bean.PreDate);
          this.$set(this.formInline, 'Location', bean.Location);
          this.$set(this.formInline, 'OperatorName', bean.OperatorName);
          this.$set(this.formInline, 'IsNon', bean.IsNon !== 0);
          this.$set(this.formInline, 'CreateDate', bean.CreateDate);
          this.$set(this.formInline, 'OperatorID', bean.OperatorID);
          this.$set(this.formInline, 'Remark', bean.Remark);
          this.$set(this.formInline, 'SpecialRequest', bean.SpecialRequest);
          this.$set(this.formInline, 'AvailableDays', bean.AvailableDays);
          this.$set(this.formInline, 'GuestName', bean.GuestName);
          if (bean.NeedAssay !== null) this.$set(this.formInline, 'NeedAssay', bean.NeedAssay !== 0);
          this.batchNumberList = bean.carOrderBatchList;
          if (this.batchNumberList.length > 0) {
            this.batchNumberList.forEach((itme, key) => {
              itme.id = key + 1;
              itme.uid = this.$utils.getUid();
            });
          }
          this.detailTable.carOrderBatchList = this.batchNumberList;
          this.licenseNumberList = bean.carOrderListList;
          if (this.licenseNumberList.length > 0) {
            this.licenseNumberList.forEach((itme, key) => {
              itme.id = key + 1;
              itme.uid = this.$utils.getUid();
            });
          }
          this.detailTable.carOrderListList = this.licenseNumberList;
          this.detailInfo = bean;
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
            this.$nextTick(() => {
              this.$refs.licenseTable.initTable();
            })
          })
        });
      },
      // 添加table数据列
      async addNewBatchNumberData(callback) {
        let beanData = [];
        if (this.$route.name === 'billLadingUnload' || this.$route.name === 'addBillLadingUnload') {
          let {bean} = await this.$services.post({
            type: 'BUSINESS',
            url: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? 'getOutCarBatchId' : 'getInCarBatchId',
            params: {
              accountId: this.userInfor.accountId,
              bargainId: this.formInline.BargainID,
              goodsId: this.formInline.GoodsID,
              guestId: this.formInline.GuestID,
              billId: this.formInline.BillID,
              blNumber: this.formInline.BLNumber,
            },
          });
          beanData = bean;
        }
        this.batchNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.batchNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.batchNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            AccountID: this.userInfor.accountId,
            ShowIndex: 1,
            State: 0,
            updateFlg: 'add',
            IsOutTrade: false,
            IsInTrade: true,
            IsTax: false,
            BatchID: beanData[0] ? beanData[0].BatchID : '',
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      addNewLicenseNumberData(callback) {
        this.licenseNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.licenseNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.licenseNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            SmallBLNO: this.formInline.BLNO,
            AccountID: this.userInfor.accountId,
            ListId: this.licenseNumberList.length + 1,
            ShowIndex: 1,
            State: 0,
            updateFlg: 'add',
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      // 合同号弹出选择
      getBargainEven() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.Name ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? '08' : '09',
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        }).then(res => {
          this.bargainList = res.bean;
        });
      },
      // 产品弹出选择
      getRefGoodsAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          bargainId: this.formInline.BargainID,
          goodsId: this.formInline.GoodsID,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getRefGoods',
          params,
        }).then(res => {
          this.getRefGoodsList = res.bean;
        });
      },
      // 客户弹出选择
      getRefVGuestAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? '08' : '09',
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getRefVGuest',
          params,
        }).then(res => {
          this.guestIDList = res.bean;
        });
      },
      // 提单号接口
      getBlnoEven() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getBlno',
          params,
        }).then(res => {
          this.getBlnoList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getTGuest',
          params,
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      selectRow(row) {
        this.$refs.pointSet.setCurrentRow(row);
      },
      clickFn(row) {
        this.$refs.pointSet.clearSelection();
        this.$refs.pointSet.toggleRowSelection(row);
      },
      // 用户选择表格事件
      batchNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.batchNumberUserSelectId = idAll;
      },
      licenseNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.licenseNumberUserSelectId = idAll;
      },
      // 删除
      batchNumberDelete() {
        if (this.batchNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.batchNumberUserSelectId.forEach(itme => {
            this.batchNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.batchNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      licenseNumberDelete() {
        if (this.licenseNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.licenseNumberUserSelectId.forEach(itme => {
            this.licenseNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.licenseNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      // 获取附加合同
      getAttachBargainAPI() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getAttachBargain',
          params: {
            accountId: this.userInfor.accountId,
            goodsId: this.formInline.GoodsID,
            guestId: this.formInline.GuestID,
            bargainId: this.formInline.BargainID
          }
        }).then(res => {
        })
      },
      // 批号列表数据删除
      // batchNumCompleteDelete() {
      //
      // },
      // 保存接口
      // 数据校验
      dataCheck() {
        let start = false;
        let arr = [
          {key: 'Name', tips: '请选择客户',},
          {key: 'BargainID', tips: '请选择合同号',},
          {key: 'CEGoodsName', tips: '请选择产品',},
          {key: 'BLNumber', tips: '请填写提单数',},
          {key: 'PreDate', tips: '请选择预计日期',},
          {key: 'GoodsID', tips: '请选择产品',},
          {key: 'GuestID', tips: '请选择客户',},
        ];
        arr.forEach(itme => {
          if (!this.detailInfo[itme.key]) {
            start = true;
            this.$message({
              message: itme.tips,
              type: 'warning',
            });
          }
        });
        return start;
      },
      checkForm() {
        this.$refs['topForm'].validate((valid) => {
          if (valid) {
            this.complete();
          } else {
            this.$message({
              message: '请将选项填写完整',
              type: 'warning',
            });
            return false;
          }
        });
      },
      complete() {
        let batchNumber = 0;
        let batchStart = false;
        this.batchNumberList.forEach((itme, key) => {
          if (itme.updateFlg !== 'delete') {
            if (!itme.IsTax) itme.IsTax = 0;
            if (!itme.IsInTrade) itme.IsInTrade = 0;
            if (!itme.IsOutTrade) itme.IsOutTrade = 0;
            if (itme.IsTax === 1 && itme.IsInTrade === 1) {
              this.$message({
                message: '保税请选择外贸',
                type: 'warning',
              });
              batchStart = true;
            }
            if (itme.IsInTrade === 1 && itme.IsOutTrade === 1) {
              this.$message({
                message: '内贸外贸不能同时选择',
                type: 'warning',
              });
              start = true;
            }
            if (this.$route.name === 'addBillLadingUnload') {
              if (itme.IsInTrade != 1 && itme.IsOutTrade != 1) {
                this.$message({
                  message: '内贸外贸必须选择一个',
                  type: 'warning',
                });
                start = true;
              }
            }
            if (itme.Number === undefined) {
              this.$message({
                message: '请填写数量',
                type: 'warning',
              });
              start = true;
            }
            batchNumber = batchNumber + Number(itme.Number);
            let keyList = Object.keys(itme);
            keyList.forEach(keyListConter => {
              this.licenseNumberClo.forEach(licenseNumberCloConter => {
                if (!licenseNumberCloConter.isNull && (itme[licenseNumberCloConter.field] === undefined || itme[licenseNumberCloConter.field] === null || itme[licenseNumberCloConter.field] === '')) {
                  this.$message({
                    message: `${licenseNumberCloConter.fieldAlias}数据未填写`,
                    type: 'warning',
                  });
                  batchStart = true
                }
              })
            })
          }
          itme.ShowIndex = Number(itme.ShowIndex);
          // delete itme.uid;
          // delete itme.id;
          if (!itme.updateFlg) itme.updateFlg = 'update';
        });
        if (batchStart) return false;
        if (this.batchNumberList[0] && batchNumber !== Number(this.batchNumberList[0].CanNumber)) {
          this.$message({
            message: '罐号' + this.orderTypeC('发货量', '卸货量') + '不等于提单数！',
            type: 'warning',
          });
          return false;
        }
        this.licenseNumberList.forEach((itme, key) => {
          if (itme.Number === undefined) {
            this.$message({
              message: '请填写每车数量',
              type: 'warning',
            });
          }
          let keyList = Object.keys(itme);
          keyList.forEach(keyListConter => {
            this.batchNumberCol.forEach(batchNumberColConter => {
              if (!batchNumberColConter.isNull && (itme[batchNumberColConter.field] === undefined || itme[batchNumberColConter.field] === null || itme[batchNumberColConter.field] === '')) {
                this.$message({
                  message: `${batchNumberColConter.fieldAlias}数据未填写`,
                  type: 'warning',
                });
                batchStart = true
              }
            })
          });
          // delete itme.uid;
          // delete itme.id;
          if (!itme.updateFlg) itme.updateFlg = 'update';
        });
        if (batchStart) return false;
        this.detailInfo.carOrderBatchList = this.batchNumberList;
        this.detailInfo.carOrderListList = this.licenseNumberList;
        this.detailInfo = Object.assign(this.detailInfo, this.formInline);
        this.detailInfo.GoodsName = this.formInline.CEGoodsName;
        this.detailInfo.updateFlg = (this.type === 'edit' || this.type === 'info') ? 'update' : 'add';
        this.detailInfo.IsNon = this.detailInfo.IsNon ? 1 : 0;
        this.detailInfo.NeedAssay = this.detailInfo.NeedAssay ? 1 : 0;
        if (this.type === 'add') {
          this.detailInfo.AccountID = this.userInfor.accountId;
          this.detailInfo.MainOrderID = this.MainOrder;
          this.detailInfo.ServiceID = this.getServiceIdList[0].ServiceID;
          this.detailInfo.OrderType = this.$route.name === 'addBillLadingLading' ? 3 : 2;
          this.detailInfo.State = 0;
          this.detailInfo.IsNon = Number(this.formInline.IsNon);
          this.detailInfo.Number = Number(this.formInline.BLNumber);
          this.detailInfo.Unit = 0;
          this.detailInfo.GoodsID = this.formInline.GoodsID;
          this.detailInfo.operatorId = this.userInfor.userName;
          // this.detailInfo.OperatorID = 'Admin';
          this.detailInfo.CreateDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.dataCheck()) return false;
        this.saveTest().then(r => {
          this.$services.postLoading({
            type: 'BUSINESS',
            url: 'save',
            params: {
              data: JSON.stringify(this.detailInfo),
            },
          }).then(res => {
            if (res.bean) {
              this.$message({
                message: '保存成功',
                type: 'success',
              });
              this.editStart = true;
              this.addStart = true;
              this.detail(this.id);
              this.$forceUpdate();
              storage.$set({
                key: 'customerServiceTable',
                parameter: true,
              });
              this.$forceUpdate();
            }
          });
        })

      },
      saveTest() {
        return new Promise((res, rej) => {
          this.$services.postLoading({
            type: 'BUSINESS',
            url: 'orderValidateBeforeSave',
            params: {
              accountId: this.userInfor.accountId,
              bargainId: this.detailInfo.BargainID,
              guestId: this.detailInfo.GuestID,
              orderType: this.detailInfo.OrderType,
              goodsId: this.detailInfo.GoodsID,
              tGuestId: this.detailInfo.GuestID
            },
          }).then(re => {
            if (re.code === '000') {
              res();
            }
          })
        });

      },
      batchInitCol() {
        this.carOrderBatch.length > 0
        && (this.batchNumberCol = this.carOrderBatch.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            if (info.fieldName === 'TankID') {
              info.tips = '...';
              info.dialog = 'showTankID';
            }
            return info;
          })
        );
      },
      licenseInitCol() {
        this.carOrderList.length > 0
        && (this.licenseNumberClo = this.carOrderList.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      },
      inputChangeEven(key) {
        if (key === 'AvailableDays') {
          let newDay = dayjs(this.formInline.BLBeginDate).unix();
          let s = (Number(this.formInline.AvailableDays) - 1) * 86400 + newDay;
          this.formInline.BLEndDate = dayjs.unix(s).format('YYYY-MM-DD HH:mm:ss');
        }
        switch (key) {
          case 'CEGoodsName':
            this.formInline.GoodsID = '';
            break;
          case 'Name':
            this.formInline.GuestID = '';
            break;
          case 'TGuestName':
            this.formInline.TGuestID = '';
            break;
          default:
            break;
        }
      },
      datePickerEven(key) {
        if (key === 'BLBeginDate') {
          this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(dayjs(this.formInline.BLBeginDate).unix() + (86400 * 3)).format('YYYY-MM-DD HH:mm:ss'))} 23:59:59`;
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
        else if (key === 'BLEndDate') {
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
      },
      clearBatchNumberList() {
        this.batchNumberList.forEach((batchInfo, batchKey) => {
          batchInfo.updateFlg = 'delete';
          this.batchNumberList.splice(batchKey, batchInfo);
        });
      }
    },
    watch: {
      'formInline.GuestID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.GoodsID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.BargainID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.TGuestID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      carOrderBatch() {
        this.batchInitCol();
      },
      carOrderList() {
        this.licenseInitCol();
      },
      licenseNumberClo() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      batchNumberCol() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      activeName(val) {
        if (val === '车号信息') {
          this.$nextTick(() => {
            this.$refs.licenseTable.initTable();
          });
        }
        else if (val === '批号信息') {
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
          });
        }
      },
      '$route.name': function () {
        /* this.init();
         this.fromList.forEach(itme => {
           this.$set(this.formInline, itme.key, '');
         });*/
      },
    },
  };
</script>
<style lang="scss">
  .edit {
    .el-upload__input {
      display: none;
    }
    .edit_modle {
      overflow-y: scroll;
    }
    .el-input-group__append .el-button {
      margin: 0;
    }
    .edit_table {
      width: 100%;
      min-height: 400px;
    }
    .edit_header {
      display: flex;
      .upload-demo {
        margin: 0 10px;
      }
    }
    .el-autocomplete {
      width: 100%;
      input {
        width: 100%;
      }
    }
  }
</style>
